import { render, staticRenderFns } from "./schoolModify.vue?vue&type=template&id=d341fca2&scoped=true"
import script from "./schoolModify.vue?vue&type=script&lang=ts"
export * from "./schoolModify.vue?vue&type=script&lang=ts"
import style0 from "./schoolModify.vue?vue&type=style&index=0&id=d341fca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d341fca2",
  null
  
)

export default component.exports